const SET_MODEL = 'SET_MODEL'
const UPDATE_MODEL = 'UPDATE_MODEL'

const state = {
  model: {},
  saving: false,
  saved: false
}

const actions = {
  setModel ({ commit }, model) {
    commit(SET_MODEL, {...model})
  },
  updateProperty ({ commit }, { key, value }) {
    commit(UPDATE_MODEL, { [key]: value })
  }
}

const mutations = {
  [SET_MODEL] (state, model) {
    state.model = model
  },
  [UPDATE_MODEL] (state, model) {
    state.model = {...state.model, ...model}
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/draftForm.js